<template>
  <ul class="currency-list">
    <li
      v-for="currency of currencies"
      :key="currency.id"
    >
      <app-radio-button-small
        :offset="16"
        name="currency"
        :class="['currency-list__item', {'active': activeCurrency === currency.currency}]"
        :value="currency.currency"
        :active="activeCurrency === currency.currency"
        :message="getMessage(currency)"
        @radioChange="changeCurrency"
      />
    </li>
  </ul>
</template>

<script>
import AppRadioButtonSmall from '../AppRadioButtonSmall/AppRadioButtonSmall';

export default {
  name: 'CurrencyList',
  components: {
    AppRadioButtonSmall,
  },
  props: {
    currencies: {
      type: Array,
      default: () => [],
    },
    activeCurrency: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentCurrency: '',
    };
  },
  mounted() {
    this.currentCurrency = this.activeCurrency;
  },
  methods: {
    changeCurrency(currency) {
      this.currentCurrency = currency;
      this.$emit('changeCurrency', currency);
    },
    getMessage(currency) {
      if (currency.cur_description && currency.currency) {
        return `${currency.cur_description} (${currency.currency})`;
      }
      return currency.currency;
    },
  },
};
</script>

<style lang="scss" scoped>
  .currency-list {
    list-style-type: none;
    padding: 0;
    max-height: 50vh;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
     }
  }
  .currency-list__item {
    box-sizing: content-box;
    display: flex;
    align-items: center;
    padding: 4px 0;
    color: var(--text-main-color);
    opacity: 0.5;
    min-height: 30px;
  }
  .currency-list__item.active {
    opacity: 1;
  }
</style>
